<template>
  <div class="account-number mt-2">
    <div v-if="loader == true">
      <b-skeleton animation="wave" width="300px" :height="'30px'"></b-skeleton>
    </div>
    <div v-else-if="loader == false">
      <span>Numéro de compte: </span>
      <span v-if="account_number !== ''">
        <b>{{ account_number }}</b>
      </span>
    </div>
  </div>
</template>

<script>
import { subscriber } from "@/services/";
import _ from "lodash";
export default {
  name: "AccountNumber",
  components: {},
  data() {
    return {
      account_number: "",
      loader: false,
    };
  },
  created: async function () {
    this.loader = true;
    await subscriber.business_account_number().then((response) => {
      if (_.isUndefined(response.error)) {
        this.account_number = response.account_number;
        this.$store.state.core.business_account.account_number =
          this.account_number;
        this.loader = false;
      } else {
        this.loader = false;
        this.account_number = "Non attribué";
      }
    });
  },
  methods: {},
};
</script>
<style scoped>
.account-number {
  font-size: 18px !important;
  line-height: 20px;
}
</style>